<template>
  <div>
    <div class="ibox float-e-margins">
      <brand-header></brand-header>
      <brand-content></brand-content>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { BRAND_SET } from '../../../store/mutation-types'

import Header from './Brand/Header'
import Content from './Brand/Content'

export default {
  data () {
    return {
    }
  },
  components: {
    brandHeader: Header,
    brandContent: Content
  },
  watch: {
    $route (to, from) {
      this.loadBrand()
    }
  },
  mounted () {
    this.loadBrand()
  },
  methods: {
    async loadBrand () {
      try {
        let resp = await axios.get(`/advertisers/brands/${this.$route.params.id}`)
        this.$store.commit(BRAND_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading lists', error)
      }
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand.vue